<section class="searchresult-splash voyage-finderr" [style.background-image]="'url(/../../../../assets/images/' + background + ')'">
  <div class="content">
    <!-- added conditional rendering of two part one if we have isFinder(input passed if we have voyage page) -->
    <div *ngIf="isFinder; else otherContent">
      <h1 class="finder-title left-border-heading">
        {{title}}
      </h1>
      <p class="finder-heading">Route Finder helps you find the best RoRo and PCTC shipping lines with current
        schedules and rates to
        transport your shipment from one port to another. </p>
      <h1 class="finder-subHeading">Where do you want to ship?</h1>
    </div>
    <ng-template #otherContent>
      <div>
        <h1>{{title}}</h1>
      </div>
    </ng-template>
    <div class="container p-0 check-group">
      <form>
        <div class="form-check-inline">
          <label class="form-check-label">
            Find Route By : 
          </label>
        </div>
        <div class="form-check-inline">
          <label class="form-check-label">
            <input type="radio" class="form-check-input find-route-box" name="optradio" checked (click)="setSearchBy('port')"> Port
          </label>
        </div>
        <div class="form-check-inline disabled">
          <label class="form-check-label">
            <input type="radio" class="form-check-input find-route-box" name="optradio" (click)="setSearchBy('country')" [checked]="true"> Country
          </label>
        </div>
      </form>
    </div>
    <div class="container p-0">
      <div class="search-section">
        <form [formGroup]="portForm" *ngIf="searchRouteBy=='port'" class="search-section-right" (ngSubmit)="onSearch()">
          <div class="select-sec">
            <label>Select Origin</label>
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="fromCountry" [options]="sourceCountries" optionLabel="countryName"
                  [filter]="true" filterMatchMode="startsWith" filterMatchMode="startsWith" placeholder="From Country"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onSourceCountryChange($event)">
                </p-dropdown>
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-multiSelect formControlName="fromPort" [options]="sourcePort" optionLabel="portName"
                  defaultLabel="From Port" [selectedItemsLabel]="'{0} ports selected'" [filter]="true"
                  filterMatchMode="startsWith" selectionLimit="5" [maxSelectedLabels]="1"
                  (onChange)="onSourcePortChange($event)">
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div class="revert-arrow">
          </div>
          <div class="select-sec">
            <label>Select Destination</label>
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="toCountry" [options]="destinationCountries" optionLabel="countryName"
                  [filter]="true" filterMatchMode="startsWith" placeholder="To Country"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onDestinationCountryChange($event)">
                </p-dropdown>
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-multiSelect formControlName="toPort" [options]="destinationPort" optionLabel="portName"
                  defaultLabel="To Port" [selectedItemsLabel]="'{0} ports selected'" [filter]="true"
                  filterMatchMode="startsWith" selectionLimit="5" [maxSelectedLabels]="1">
                </p-multiSelect>
              </div>
            </div>
          </div>
          <div class="select-sec select-date-sec">
            <label>Date</label>
            <div class="select-section-relative input-section">
              <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
            </div>
          </div>
          <div class="btn-go-sec">
            <button pButton type="submit" label="Submit"
              class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </form>
        <form [formGroup]="portForm" *ngIf="searchRouteBy=='country'" class="search-section-right" (ngSubmit)="onSearchByCountry()">
          <div class="select-sec">
            <label>Select Originn</label>
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="fromCountry" [options]="sourceCountries" optionLabel="countryName"
                  [filter]="true" filterMatchMode="startsWith" filterMatchMode="startsWith" placeholder="From Country"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onSourceCountryChange($event)">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="revert-arrow">
          </div>
          <div class="select-sec">
            <label>Select Destination</label>
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="toCountry" [options]="destinationCountries" optionLabel="countryName"
                  [filter]="true" filterMatchMode="startsWith" placeholder="To Country"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onDestinationCountryChange($event)">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="select-sec select-date-sec">
            <label>Date</label>
            <div class="select-section-relative input-section">
              <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
            </div>
          </div>
          <div class="btn-go-sec">
            <button pButton type="submit" label="Submit"
              class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </form>
      </div>
      <div class="note" *ngIf="isOpenSearch && filterType== 'LandingPageSearch'">
        Click on submit to see the results between {{fromPort?.portName}} and {{toPort?.portName}}. <br>
        If you want to search for schedules between other ports, please register for free.
        <div class="note-register"><a routerLink='/planselection'>Register here</a></div>
      </div>
    </div>
  </div>
</section>

<section class="bg-image-splash">
</section>
